import type { ReadInputBarcodeFormat } from "zxing-wasm/reader";

/** Public symbology names (Scandit-style) mapped to zxing-wasm format names. */
export const SYMBOLOGY_MAP = {
  ean13: "EAN-13",
  ean8: "EAN-8",
  upca: "UPC-A",
  upce: "UPC-E",
  code128: "Code128",
  code39: "Code39",
  code93: "Code93",
  itf: "ITF",
  codabar: "Codabar",
  qr: "QRCode",
  datamatrix: "DataMatrix",
  pdf417: "PDF417",
  aztec: "Aztec",
} as const satisfies Record<string, ReadInputBarcodeFormat>;

export type Symbology = keyof typeof SYMBOLOGY_MAP;

export function toZXingFormats(symbologies: Symbology[]): ReadInputBarcodeFormat[] {
  return symbologies.map((s) => SYMBOLOGY_MAP[s]);
}

/** Reverse of SYMBOLOGY_MAP: zxing-wasm format name → public symbology key. */
const ZXING_TO_SYMBOLOGY = Object.fromEntries(
  Object.entries(SYMBOLOGY_MAP).map(([key, zx]) => [zx, key]),
) as Record<string, Symbology>;

/**
 * Map a zxing-wasm result format ("Code128", "EAN-13", …) back to the public
 * symbology key ("code128", "ean13", …) so a scan result speaks the same
 * vocabulary as the `symbologies` option — consumers compare against the keys
 * they passed in. Unknown formats pass through unchanged.
 */
export function fromZXingFormat(format: string): string {
  return ZXING_TO_SYMBOLOGY[format] ?? format;
}
